/**
 * Website Leads — top-level sidebar group.
 *
 * (Formerly "Missed Call Leads" — renamed 2026-07-15. Same treatment: FB-ads
 * NI leads reassigned into a call-first flow, allotted daily by agent tenure,
 * with the old WhatsApp chat hidden from the new agent via freshStartAt.)
 *
 * File/export identifiers kept as *MissedCallLeads* to avoid churning every
 * import site; only the visible label, URL, and icon changed.
 *
 * Visibility: everyone who RECEIVES website leads must see the nav. The daily
 * cron allots to non-cohort WA calling agents (whatsappAgent=true) AND the
 * legacy missedCallTeam (whose 4 agents have whatsappAgent=false). So gate on
 * (whatsappAgent || missedCallTeam), plus supervisors + cohort managers.
 */

import React from "react";
import { FormattedMessage } from "react-intl";
import { IconWorld } from "@tabler/icons";
import { getDecryptDataFromLocal } from "../../utils/encrypt";

const role = Number(getDecryptDataFromLocal("setRole"));
const isWhatsAppAgent = (() => { try { return localStorage.getItem("whatsappAgent") === "true"; } catch (e) { return false; } })();
const isMissCallAgent = (() => { try { return localStorage.getItem("missedCallTeam") === "true"; } catch (e) { return false; } })();
const isBulkWaManager = (() => { try { return localStorage.getItem("bulkWaManager") === "true"; } catch (e) { return false; } })();
const isSupervisor = role === 1 || role === 17 || isBulkWaManager;
const isCohortManager = role === 13 || role === 14;

export const SHOULD_SHOW_MISSED_CALL_LEADS = isWhatsAppAgent || isMissCallAgent || isSupervisor || isCohortManager;

export const MissedCallLeadsTab = {
  id: "website-leads",
  title: <FormattedMessage id="Website Leads" defaultMessage="Website Leads" />,
  type: "group",
  children: SHOULD_SHOW_MISSED_CALL_LEADS ? [
    {
      id: "website-leads-item",
      title: <FormattedMessage id="Website Leads" defaultMessage="Website Leads" />,
      type: "item",
      url: "/dashboard/website-leads",
      icon: IconWorld,
      breadcrumbs: false,
    },
  ] : [],
};
